module.exports = __webpack_public_path__ + "media/assets/images/blog/polly_block_1-small-010afd821fba6d1f1fc7c037f5b4be1f.png";